<template>
  <div class="not-open-model">
    <div class="model-inner">
      海外航线在线值船请前往皇家加勒比APP<br/>或<br/><a href="https://www.royalcaribbean.com/booked">www.royalcaribbean.com</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckInIndex",
  created() {
    let href = window.location.href;
    if(href.indexOf('www.rclolci.com')>=0) {
      window.location.href = "https://www.rcclchina.com.cn/Rccl.Olci/Olci/CheckInIndex";
    }
  }
}
</script>

<style scoped lang="less">
.not-open-model {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("https://resource.rcclchina.com.cn/wechatMiniProgram/ship-bg-SC.jpg");
  background-size: 100% 100%;
  & .model-inner {
    font-size: .8rem;
    text-align: center;
    line-height: 1.5;
    margin: 28vh auto 0;
    padding: .6rem;
    width: 325px;
    font-weight: 500;
    background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
    color: #FFFFFF;
    & > a {
      text-decoration: underline;
      color: #FFFFFF;
    }
  }
}
</style>